/**
 * Create a `File` object with a different name from a given `File` object.
 * @param originalFile The original `File` object.
 * @param filename The new name. If a function is provided, it will be called
 *  with the original `File` object and return the new name.
 * @returns A new `File` object with the same content but a different name.
 */
export function renameFile(
    originalFile: File,
    filename: string | ((file: File) => string),
): File {
    const newName =
        typeof filename === 'function' ? filename(originalFile) : filename;
    return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
    });
}
